<script>
export default {}
</script>

<template>
	<div class="p-20 p-xl-60 card">
		<div class="card-body">
			<slot></slot>
		</div>
	</div>
</template>
